import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';
import { accountFromDto } from '../../../account.dto';

export class Controller {

    /** @ngInject */
    constructor($q, $state, $uibModal, AccountsResource, Alert, GroupsResource) {
        this.$q = $q;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
        this.username = '';
        this.searchText = '';
        this.form = 'existingForm';
        this.st = new SmartTable();
        var ctrl = this;
        this.callServer = function callServer(tableState) {
            ctrl.tableState = tableState;
            ctrl.isLoading = true;
            var pagination = tableState.pagination;
            var page = pagination.start / pagination.number;
            var number = pagination.number;
            var searchText = (tableState.search.predicateObject ? tableState.search.predicateObject.searchText : '');
            var sort = tableState.sort.predicate;
            var sortReverse = tableState.sort.reverse;
            if (ctrl.reloadTable || ctrl.page != page || ctrl.number != number || ctrl.searchText != searchText || ctrl.sort != sort || ctrl.sortReverse != sortReverse) {
                ctrl.reloadTable = false;
                ctrl.page = page;
                ctrl.number = number;
                ctrl.searchText = searchText;
                ctrl.sort = sort;
                ctrl.sortReverse = sortReverse;
                ctrl.GroupsResource
                    .getAllAccountsInCompanyAndNotInGroupWithPagination(ctrl.companyId, ctrl.group.id, ctrl.page, ctrl.number, ctrl.searchText, ctrl.sort, ctrl.sortReverse)
                    .then(dto => {
                        pagination.totalItemCount = dto.totalElements;
                        pagination.numberOfPages = dto.totalPages;
                        ctrl.st.displayedItems = dto.content.map(accountFromDto);
                })
                .finally(() => ctrl.isLoading = false);
            }
        }
    }

    focusNewForm() {
        this.form = 'newForm';
    }

    focusExistingForm() {
        this.form = 'existingForm';
        this.searchText = '';
        if (this.tableState) {
            this.reloadTable = true;
        }
        this.username = '';
    }

    save() {
        const rejectAlreadyExistingAccount = (account) => {
            if (account.justCreated) {
                return this.$q.resolve(account);
            } else {
                this.$uibModal
                    .open({component: 'companyUserDirectoriesManageUserAddAccountAccountAlreadyExists'}).result
                    .then(() => this.$state.go('company.user-directories.manage-account', {accountId: account.id}));
                return this.$q.reject();
            }
        };

        this.isSaving = true;
        (this.form === 'newForm'
                ? this.GroupsResource
                    .addNewUserToGroup(this.companyId, this.group.id, this.username)
                    .then(accountFromDto)
                    .then(rejectAlreadyExistingAccount)
                : this.AccountsResource
                    .copyUsersToGroup(this.companyId, [this.group.id], this.st.selectedIds)
        )
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.user-directories.manage-group.accounts.add.added'))
            .finally(() => this.isSaving = false)
    }

    saveDisabled() {
        return this.isSaving || this.isSearching ||
            this.form === 'newForm' && !this.username ||
            this.form === 'existingForm' && !this.st.selectedItems.length;
    }

}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/add/add-account-to-group.controller.js